class GiftWrappingComponent extends HTMLElement {
  constructor() {
    super();

    this.cartDrawer = document.querySelector("m-cart-drawer");
    this.giftWrapId = this.dataset.giftWrapId;
    this.giftWrapping = this.dataset.giftWrapping;
    this.cartItemsSize = parseInt(this.getAttribute("cart-items-size")) || 0;
    this.giftWrapsInCart = parseInt(this.getAttribute("gift-wraps-in-cart")) || 0;
    this.itemsInCart = parseInt(this.getAttribute("items-in-cart")) || 0;
    this.loadingIcon = this.querySelector(".m-gift-wrapping--loading");
    this.cart = document.querySelector("m-cart-drawer");

    // Checkbox + textarea inside this component
    this.checkbox = this.querySelector('[name="attributes[gift-wrapping]"]');
    this.noteTextarea = this.querySelector(".m-gift-wrapping--note textarea");

    // Form:
    // - on cart page: the wrapping component is inside the form
    // - on cart drawer: the wrapping component is outside, so use #cart-drawer-form
    this.form = this.closest("form") || document.querySelector("#cart-drawer-form");

    // Checkbox change -> update cart + toggle required
    if (this.checkbox) {
      this.checkbox.addEventListener("change", (event) => {
        const checked = event.target.checked;
        checked ? this.setGiftWrapping() : this.removeGiftWrapping();
        this.toggleNoteRequired(checked);
      });
    }

    // Original Minimog sync logic
    if (this.cartItemsSize == 1 && this.giftWrapsInCart > 0) {
      this.removeGiftWrapping();
    } else if (this.giftWrapsInCart > 0 && this.giftWrapsInCart != this.itemsInCart) {
      this.setGiftWrapping();
    } else if (this.giftWrapsInCart > 0 && this.giftWrapping === "false") {
      this.setGiftWrapping();
    } else if (this.giftWrapsInCart == 0 && this.giftWrapping === "true") {
      this.setGiftWrapping();
    }

    // Apply correct required state on load
    if (this.checkbox) {
      this.toggleNoteRequired(this.checkbox.checked);
    }

    // Block checkout submit if checkbox checked and note empty
    if (this.form && this.checkbox && this.noteTextarea) {
      this.form.addEventListener("submit", (e) => {
        // Try to detect if this submit is for checkout (button with name="checkout")
        const submitter = e.submitter || document.activeElement;

        const isCheckout =
          submitter &&
          (submitter.name === "checkout" || submitter.getAttribute("name") === "checkout");

        if (
          isCheckout &&
          this.checkbox.checked &&
          this.noteTextarea.value.trim() === ""
        ) {
          e.preventDefault();
          alert("Please enter your gift message.");
          this.noteTextarea.focus();
        }
      });
    }
  }

  // Toggle the HTML required attribute (works on cart page where textarea is inside the form)
  toggleNoteRequired(shouldBeRequired) {
    if (!this.noteTextarea) return;
    if (shouldBeRequired) {
      this.noteTextarea.setAttribute("required", "required");
    } else {
      this.noteTextarea.removeAttribute("required");
    }
  }

  setGiftWrapping() {
    const sectionsToUpdate = this.getSectionsToUpdate();

    if (this.loadingIcon) {
      this.loadingIcon.classList.add("show");
    }
    const headers = new Headers({
      "Content-Type": "application/json",
      Accept: "application/json",
    });
    const config = {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        updates: {
          [this.giftWrapId]: this.itemsInCart,
        },
        attributes: { "gift-wrapping": true },
        sections: sectionsToUpdate,
      }),
    };
    this.updateCart(config);
  }

  removeGiftWrapping() {
    const sectionsToUpdate = this.getSectionsToUpdate();

    if (this.loadingIcon) {
      this.loadingIcon.classList.add("show");
    }
    const headers = new Headers({
      "Content-Type": "application/json",
      Accept: "application/json",
    });
    const config = {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        updates: {
          [this.giftWrapId]: 0,
        },
        attributes: { "gift-wrapping": false, "gift-note": "" },
        sections: sectionsToUpdate,
      }),
    };
    this.updateCart(config);
  }

  getSectionsToUpdate() {
    let sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", {
        bubbles: true,
        detail: { sections: sections },
      })
    );
    return sections;
  }

  updateCart(request) {
    return fetch(`${MinimogSettings.routes.cart_update_url}`, request)
      .then((response) => response.json())
      .then((response) => {
        if (this.loadingIcon) {
          this.loadingIcon.classList.remove("show");
        }
        MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
          cart: response,
        });

        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: {
              cart: response,
            },
          })
        );
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define("m-gift-wrapping-component", GiftWrappingComponent);

class GiftNoteComponent extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "change",
      debounce((event) => {
        const headers = new Headers({
          "Content-Type": "application/json",
          Accept: "application/json",
        });
        const request = {
          method: "POST",
          headers: headers,
          body: JSON.stringify({
            attributes: { "gift-note": event.target.value },
          }),
        };
        fetch(`${MinimogSettings.routes.cart_update_url}`, request);
      }, 300)
    );
  }
}
customElements.define("m-gift-note-component", GiftNoteComponent);

class GiftWrappingQuantityInput extends MQuantityInput {
  constructor() {
    super();
  }

  init() {
    super.init();
    this.giftWrapping = document.querySelector("m-gift-wrapping-component");
    this.cartItemsSize = parseInt(this.getAttribute("cart-items-size")) || 0;
    this.giftWrapsInCart = parseInt(this.getAttribute("gift-wraps-in-cart")) || 0;
    this.itemsInCart = parseInt(this.getAttribute("items-in-cart")) || 0;

    // If we have nothing but gift-wrap items in the cart.
    if (this.cartItemsSize == 1 && this.giftWrapsInCart > 0) {
      this.giftWrapping && this.giftWrapping.removeGiftWrapping();
    }
    // If we don't have the right amount of gift-wrap items in the cart.
    else if (this.giftWrapsInCart > 0 && this.giftWrapsInCart != this.itemsInCart) {
      this.update();
    }
    // If we have a gift-wrap item in the cart but our gift-wrapping cart attribute has not been set.
    else if (this.giftWrapsInCart > 0 && this.giftWrapping && this.giftWrapping.length == 0) {
      this.update();
    }
    // If we have no gift-wrap item in the cart but our gift-wrapping cart attribute has been set.
    else if (this.giftWrapsInCart == 0 && this.giftWrapping && this.giftWrapping.length > 0) {
      this.update();
    }
  }

  update() {
    this.input.value = this.itemsInCart;
    this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define("m-gift-wrapping-input", GiftWrappingQuantityInput);
